/* SicilyAddict DE - etichette dei pulsanti che seguono la lingua di GTranslate (de <-> it).
   I pulsanti hanno data-sa-i18n="<chiave>" e dentro uno <span class="sa-i18n notranslate">:
   Google Translate non li tocca (il JS del tema li riscrive e la traduzione andava persa),
   quindi il testo lo mettiamo noi, dal vivo, senza ricaricare la pagina.
   Chiavi: atc, soldout, options, unavailable, preorder, contact.
   Lingua: cookie googtrans ("/de/it" -> "it") + <html lang> / classe "translated-ltr" di Google.
   Lingua sconosciuta = tedesco. Il tedesco del pulsante "Warenkorb" arriva dal Liquid
   (data-sa-de = impostazione tema sa_atc_text), gli altri da DE qui sotto.
   LEGACY: vecchie diciture dello stesso pulsante, riconosciute per chiave (non piu' mostrate). */
(function () {
  'use strict';

  var IT = { atc: 'Carrello', soldout: 'Esaurito', options: 'Scegli le opzioni', unavailable: 'Non disponibile', preorder: 'Preordina', contact: 'Contattaci' };
  var DE = { atc: 'Warenkorb', soldout: 'Ausverkauft', options: 'Wähle Deine Optionen', unavailable: 'Nicht verfügbar', preorder: 'Vorbestellung', contact: 'Kontaktiere uns' };
  /* Testi che il JS del tema scrive nel bottone al cambio variante (window.languages) */
  var LEGACY = { atc: ['In den Warenkorb', 'Zum Warenkorb', 'zum Warenkorb hinzufügen', 'Aggiungi al carrello'] };
  var THEME_KEYS = { productFormAddToCart: 'atc', productFormSoldOut: 'soldout', productFormUnavailable: 'unavailable', productFormPreOrder: 'preorder' };

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function cookieLang() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)googtrans=([^;]*)/);
      if (!m) return '';
      var parts = decodeURIComponent(m[1]).split('/');
      return (parts[parts.length - 1] || '').toLowerCase();
    } catch (e) { return ''; }
  }

  function currentLang() {
    var html = document.documentElement;
    var translated = /\btranslated-(ltr|rtl)\b/.test(html.className || '');
    var lang;
    if (translated) lang = (html.getAttribute('lang') || '').slice(0, 2).toLowerCase() || cookieLang();
    else lang = cookieLang() || 'de';
    return lang === 'it' ? 'it' : 'de';
  }

  /* Riconosce la chiave dal testo attuale (qualsiasi lingua): serve quando il tema
     cambia il bottone (es. da "Warenkorb" ad "Ausverkauft" al cambio variante). */
  function keyFromText(el, text) {
    var t = norm(text);
    if (!t) return '';
    var k;
    for (k in DE) { if (norm(DE[k]) === t || norm(IT[k]) === t) return k; }
    for (k in LEGACY) { for (var i = 0; i < LEGACY[k].length; i++) { if (norm(LEGACY[k][i]) === t) return k; } }
    var langs = window.languages || {};
    for (k in THEME_KEYS) { if (langs[k] && norm(langs[k]) === t) return THEME_KEYS[k]; }
    if (el.getAttribute('data-sa-de') && norm(el.getAttribute('data-sa-de')) === t) return 'atc';
    if (el.getAttribute('data-sa-orig') && norm(el.getAttribute('data-sa-orig')) === t) return el.getAttribute('data-sa-i18n');
    return '';
  }

  function label(el, key, lang) {
    if (lang === 'it') return IT[key] || '';
    if (key === 'atc' && el.getAttribute('data-sa-de')) return el.getAttribute('data-sa-de');
    return DE[key] || el.getAttribute('data-sa-orig') || '';
  }

  function applyOne(el, lang) {
    var span = el.classList.contains('sa-i18n') ? el : el.querySelector('.sa-i18n');
    var current = span ? span.textContent : el.textContent;
    if (!el.hasAttribute('data-sa-orig')) el.setAttribute('data-sa-orig', (current || '').trim());
    var key = keyFromText(el, current);
    if (!key) {
      /* Testo sconosciuto (es. "Hinzugefügt!" dopo l'aggiunta): lo lascia com'e' */
      if (span) key = el.getAttribute('data-sa-i18n'); else return;
    }
    var text = label(el, key, lang);
    if (!text) return;
    if (span) {
      if (span.textContent !== text) span.textContent = text;
      return;
    }
    /* Il tema ha riscritto il bottone e lo span non c'e' piu': lo rimettiamo (solo se il bottone contiene solo testo) */
    if (el.children.length) return;
    span = document.createElement('span');
    span.className = 'sa-i18n notranslate';
    span.setAttribute('translate', 'no');
    span.textContent = text;
    el.textContent = '';
    el.appendChild(span);
  }

  function apply() {
    var lang = currentLang();
    var els = document.querySelectorAll('[data-sa-i18n]');
    for (var i = 0; i < els.length; i++) {
      try { applyOne(els[i], lang); } catch (e) {}
    }
  }

  var timer = null;
  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(apply, delay || 100);
  }

  function start() {
    apply();
    /* Cambio lingua di Google Translate: lang/classe su <html> */
    new MutationObserver(function () { schedule(50); })
      .observe(document.documentElement, { attributes: true, attributeFilter: ['lang', 'class'] });
    /* Nuovi pulsanti o testo riscritto (filtri/ordinamento collezione, variante PDP, carrello) */
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        var el = t && (t.nodeType === 1 ? t : t.parentNode);
        if (!el || !el.closest) continue;
        if (el.closest('[data-sa-i18n]') || (el.querySelector && el.querySelector('[data-sa-i18n]'))) { schedule(100); return; }
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1 && (added[j].matches('[data-sa-i18n]') || added[j].querySelector('[data-sa-i18n]'))) { schedule(100); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    /* Click / cambio sul selettore GTranslate: Google applica la lingua con un po' di ritardo */
    function onWidget(e) {
      if (!e.target || !e.target.closest || !e.target.closest('.gtranslate_wrapper, .gt_selector, [data-sa-gtranslate]')) return;
      setTimeout(apply, 300);
      setTimeout(apply, 1200);
    }
    document.addEventListener('change', onWidget, true);
    document.addEventListener('click', onWidget, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
